import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { GoogleMapsAutocompleteModalPage } from './google-maps-autocomplete-modal.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule.forChild()],
  declarations: [GoogleMapsAutocompleteModalPage],
})
export class GoogleMapsAutocompleteModalPageModule {}
